/* eslint-disable jsx-a11y/label-has-associated-control */
/**
 * Renders a CustomerDetailView.
 * @returns {JSX.Element} Rendered component
 */

import LocalStorage from 'Helpers/MFXLocalStorage';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ModalOverlay from '../Common/ModalOverlay';
import Loading from '../Elements/Loading';
import QrScanner from '../Elements/QrScanner';
import SavedModal from '../Elements/SavedModal';
import apiPost from '../Hooks/apiPost';
import GenericElement from '../Utils/GenericElement';
import loadJsonData from '../Utils/loadJsonData';
import URLS from '../Utils/URLs.API';
import store, { detailViewActions } from '../../../Helpers/Stores/detailViewStoreCRM';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { getTodaysDate } from '../../../Helpers/dateHelper';

function CreateDocument(props: any): JSX.Element {
    //const viewData = useSelector((state: RootState) => state.viewData);
    const [viewData, setViewData] = useState(null as any);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [saveMessage, setSaveMessage] = useState(null as any);
    const [addForm, setAddForm] = useState<null | any>(null);
    const [recording, setRecording] = useState(false);

    useEffect(() => {
        loadForm();
    }, []);

    console.log(viewData);

    function genObject(obj, keys, val) {
        if (keys.length === 1) {
            obj[keys[0]] = val;
            return obj;
        }
        obj[keys[0]] = genObject(obj[keys[0]] ?? {}, keys.slice(1), val);
        return obj;
    }

    function loadForm() {
        loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.ViewLayouts + '?ViewName=' + props.viewName + '&LayoutName=' + (props.layoutName ?? 'default'))
            .then((data: any) => {
                if (data.Data !== null) {
                    setAddForm(data.Data.Json);
                    let emptyObject = {} as any;

                    Object.entries(data.Data.Json.DesignElements).forEach((el: any) => {
                        const keys = (el[1].Key as string).split('-');
                        emptyObject = genObject(emptyObject, keys, el[1]?.Elementtype === 'checkbox' ? false : '');
                    });
                    loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetCustomer + props.customer).then((data2: any) => {
                        if (data2.Data !== null) {
                            emptyObject.Customer = data2.Data;
                        }
                        emptyObject.TanIndex = props.tanIndex;
                        emptyObject.CustomerNumber = props.customer;
                        setViewData({ Data: emptyObject, DesignElements: data.Data.Json.DesignElements });
                        setDataLoaded(true);
                    });
                }
            })
            .catch(e => {
                console.log(e);
            });
    }

    async function handleSubmit(e: any) {
        console.log(viewData.Data);
        setDataLoaded(false);
        e.preventDefault();
        let curFormData = e.target;
        let validate = 0;

        /* ----------------- VALIDATION ------------------- */

        for (let i = 0; i < curFormData.length; i++) {
            if (curFormData.elements[i].Required && !curFormData.elements[i].value) {
                curFormData.elements[i].classList.add('required-error');
                validate++;
            }
        }

        //clear errors
        document.querySelector('required-error')?.classList.remove('required-error');
        let requiredContainer = document.getElementsByClassName('required-true');
        for (let j = 0; j < requiredContainer.length; j++) {
            let input = (requiredContainer[j] as HTMLElement).querySelectorAll('input')[1];
            if (input && !input.value) {
                let nameOfAlternative = viewData.DesignElements[input.name].Conditions && viewData.DesignElements[input.name].Conditions[0] ? viewData.DesignElements[input.name].Conditions[0].value : null;
                if (nameOfAlternative && (typeof viewData.Data[nameOfAlternative] === 'object' ? viewData.Data[nameOfAlternative]?.value : viewData.Data[nameOfAlternative])) {
                    //make a loop if more than 1 condition
                    console.log('alternative erfüllt');
                } else {
                    (requiredContainer[j] as HTMLElement).querySelector('div[class*=-control]')?.classList.add('required-error');
                    validate++;
                }
            }
        }

        if (validate > 0) {
            setDataLoaded(true);
        } else {
            const newData = {} as any;
            newData.CreateData = { ...viewData.Data };
            console.log(newData);
            apiPost('/' + LocalStorage?.getConnectionKey() + URLS.CreateDocument, newData)
                .then((data: any) => {
                    if (data.Meta.Success) {
                        curFormData.reset();
                        setSaveMessage({ success: true, message: 'Dokument (' + data.CreatedData.DocumentNumber + ') wurde erstellt.' });
                        /*if (props.viewSettings.modalButtons) {
                            props.viewSettings.modalButtons.forEach(button => {
                                if (button.action === 'toCreatedData' && (props.viewSettings.viewName === 'TaskAddView' || props.viewSettings.viewName === 'CustomerVisitAddView')) return (button.url = button.url + 'index=' + data.CreatedData.Task.Index);
                            });
                        }*/
                    } else {
                        console.log(data.Meta);
                        setSaveMessage({ success: false, message: window.Dictionary.getTranslation(14234) + ': <br/>' + data.Meta.ErrorMessages[0].Message });
                    }
                    setDataLoaded(true);
                })
                .catch(data => {
                    console.log(data);
                    setSaveMessage({ success: false, message: window.Dictionary.getTranslation(14234) + ': <br/>' + data.Meta.ErrorMessages[0].Message });

                    setDataLoaded(true);
                });
        }
    }

    function changeData(valueObject) {
        setSaveMessage(null);
        setValue(viewData.Data, valueObject.designData.Key.split('-'), valueObject.newValue);
        //---------- different conditions ----------------
        if (valueObject.designData.Conditions && valueObject.designData.Conditions[0] && valueObject.designData.Conditions[0].type === 'alternative') {
            setValue(viewData.Data, valueObject.designData.Conditions[0].value.split('-'), '');
            if (valueObject.designData.Conditions[0].value === 'PersonInChargeID' && valueObject.designData.Conditions[0].type === 'alternative') {
                setValue(viewData.Data, valueObject.designData.Conditions[0].value.replace('PersonInChargeID', 'PersonInChargeName').split('-'), '');
            }
            if (valueObject.designData.Conditions[0].value === 'PersonInChargeNumber' && valueObject.designData.Conditions[0].type === 'alternative') {
                setValue(viewData.Data, valueObject.designData.Conditions[0].value.replace('PersonInChargeNumber', 'PersonInChargeName').split('-'), '');
            }
        }
        setViewData({ ...viewData });
    }

    function setValue(data, keys, value) {
        if (keys.length === 1) data[keys[0]] = value;
        else {
            setValue(data[keys[0]], keys.slice(1), value);
        }
    }

    function getGenericElement(designD, key, uniqueIndex, idx) {
        const keys = (key as string).split('-');
        if (keys[0] === 'Data') keys.splice(0, 1);
        let value = viewData.Data;
        keys.forEach(key => {
            value = value[key];
        });
        if (keys[0] === 'Process' && process) {
            designD.ReadOnly = true;
        }

        return (
            <GenericElement
                customData={value}
                designData={{ ...designD }}
                key={uniqueIndex + idx}
                index={uniqueIndex}
                isRecording={recording}
                setRecording={val => setRecording(val)}
                disableMode={false}
                noLabel={false}
                onChangeGenericElement={(valueObject: any) => {
                    changeData({ ...valueObject, idx: idx });
                }}
                viewName="addView"
                customId={viewData.Data.Customer?.CustomerNumber}
            />
        );
    }

    return (
        <div className={`mfx-add-view ${props.viewName}`}>
            {props.children}
            {!dataLoaded && <Loading />}
            {dataLoaded && !saveMessage && (
                <>
                    <h2>{window.Dictionary.getTranslation(5482)}</h2>
                    <form id="mfx-add-form" onSubmit={handleSubmit}>
                        {addForm && (
                            <>
                                <div className="mfx-elements">
                                    {
                                        // OLD 17.01.24
                                        addForm.ElementsOrder &&
                                            addForm.ElementsOrder[0].map((key, idx) => {
                                                if (addForm.DesignElements[key]) {
                                                    const designD = addForm.DesignElements[key];
                                                    return getGenericElement(designD, key, idx, idx);
                                                }
                                                return <></>;
                                            })
                                    }
                                    {!addForm.ElementsOrder &&
                                        addForm.DesignElements &&
                                        Object.entries(addForm.DesignElements)
                                            .sort((a: any, b: any) => {
                                                return a[1].Order > b[1].Order ? 1 : -1;
                                            })
                                            .map((key: any, idx) => {
                                                return getGenericElement(key[1], key[1].Key, idx, idx);
                                            })}
                                </div>
                                <div>
                                    <button type="submit" className="send-button button center">
                                        {window.Dictionary.getTranslation(4765)}
                                    </button>
                                </div>
                            </>
                        )}
                    </form>
                </>
            )}
            {saveMessage && <SavedModal saveMessage={saveMessage} closeIcon={true} handleClose={() => window.location.reload()} />}
        </div>
    );
}

export default CreateDocument;

export function CreateDocumentProvider(props: any): JSX.Element {
    return (
        <Provider store={store}>
            <CreateDocument {...props} />
        </Provider>
    );
}

export type RootState = ReturnType<typeof store.getState>;
